import Summary from "./summary.css"
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { BarChart, Bar } from "recharts";
import { PieChart, Pie, Cell } from "recharts";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// images
import impression from "../../assets/images/group_1.png";
import ctr from "../../assets/images/CTR.png";
import earningImg from "../../assets/images/earning.png";  
import date from "../../assets/images/date_1.png";
import axios from "axios";
// chart parameters
// const earningsData = [
//     { publisher: "20-feb-2025", earnings: 5000 },
//     { publisher: "21-feb-2025", earnings: 7000 },
//     { publisher: "22-feb-2025", earnings: 6000 },
//     { publisher: "23-feb-2025", earnings: 8000 },
//     { publisher: "24-feb-2025", earnings: 7500 },
//   ];
//   const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#0088FE"];

const SummaryPanel = () => {
  const pubId = localStorage.getItem("account_id");
  const getFormattedDate = (daysAgo = 0)=>{
    const date  = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date.toISOString().split("T")[0];
  }
  const [revenue, setRevenue] = useState("");
  const [reChartData, setReChartData] = useState([]);
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(getFormattedDate(7));
  const [endDate, setEndDate] = useState(getFormattedDate(1));
  const [reportData, setReportData] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  
  const navigate = useNavigate();

  const adEarningsData = async ()=>{
    const token = localStorage.getItem("token");
    // console.log(token);
    if(!token){
      navigate("/");
    }

    try {
      const earningRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/dashboard`, {
        headers:{
          // Authorization: `Bearer ${localStorage.getItem("token")}`,``
          "Authorization": `Bearer ${token}`,
          "Accept":"application/json",
          // "Access-Control-Allow-Origin" : '*'
        },
      });
      // const earningResTwo = earningRes.toFixed(2)
      setRevenue(earningRes.data.data);
      // console.log(earningRes.data.data);      
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  }

  const chartData = async ()=>{
    try {
      const token = localStorage.getItem("token");
      if(!token){
        console.error("No token found! User not authenticated.");
        return;
      }      
      const chartRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/pub/impressionRevenue`, {
        headers:{
          "Authorization": `Bearer ${token}`,
          "Accept":"application/json",
          // "Access-Control-Allow-Origin" : '*'
        },
        // withCredentials: true,
      });      
      // console.log("API Response:", chartRes.data.data);

      const transformedData = chartRes.data.data.map(barData=>({
        date:barData.date,
        impression:barData.impressions || 0,
        revenue:barData.revenue.toFixed(5) || 0,
      }));

      // console.log("Transformed Data:", transformedData);

      setReChartData(transformedData);

    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  }
  // reporting
  const allDaysReport = async ()=>{
    try {
      const token = localStorage.getItem("token");
      if(!token){
        console.error("No token found! User not authenticated.");
      return;
      }   
      const dayWiseReportRes = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/pub/reportByAdUnit?page=1`, 
        { startDate, endDate },
      {
        headers:{
          "Authorization": `Bearer ${token}`,
          "Accept":"application/json",
          // "Access-Control-Allow-Origin" : '*'
        }
    }
  );
      // console.log(dayWiseReportRes.data); 
      setReportData(dayWiseReportRes?.data?.data?.data || []);
      setDataColumns(dayWiseReportRes?.data?.data?.columns);
      console.log(dataColumns);
      

    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  }
  // define which columns you want to display
  const allowedColumns = ["p_ad_display_name", "requests", "page_views", "imp", "ctr", "pubRev", "pub_eCPM"];
  // filter the API columns before rendering
  // const visibleColumns = dataColumns?.filter(col => allowedColumns.includes(col));
      let visibleColumns = dataColumns?.filter(col => {
      if (col === "page_views" && pubId !== "c79a2d5f-2dc7-41c7-8927-463bc022327e") {
        return false; // hide page_views for other publishers
      }
      return allowedColumns.includes(col);;
    });
  const headerMapping = {
      p_ad_display_name: "Ad Unit",
      imp: "Impressions",
      ctr: "CTR",
      pubRev: pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? "Publisher Rev (₹)" : "Publisher Rev ($)",
      requests:"Request",
      page_views:"Page Views",
      pub_eCPM: pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? "PubeCPM(₹)" : "PubeCPM($)",
  };
  useEffect(()=>{
    adEarningsData();
    chartData();
    allDaysReport();
    const pubId = localStorage.getItem("account_id");
    if (pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      navigate("/reporting");
    }
  }, []);
    return(
        <section className="dashboardBody">
        <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
      {
         revenue.length > 0 ?
         <>
         {/* first col start */}
          <div className="col-lg-3 col-md-3 col-sm-4">
            <div className={`card shadow-none border bg-gradient-start-1-0 h-100`}>
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-light mb-1">Earnings</p>
                    <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[0]?.earning.toFixed(2)}`:`$${revenue[0]?.earning.toFixed(2)}`}</h6>
                  </div>
                  <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                    <img src={impression} />
                  </div>
                </div>
                <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                  {/* <span className="d-inline-flex align-items-center gap-1 text-success-main"></span>  */}
                      <img src={date} /> <span>Yesterday</span>
                </div>
              </div>
            </div>
          </div>
          {/* second col start */}
          <div className="col-lg-3 col-md-3 col-sm-4">
            <div className={`card shadow-none border bg-gradient-start-1-1 h-100`}>
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-light mb-1">Earnings</p>
                    <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[1]?.earning.toFixed(2)}` : `$${revenue[1]?.earning.toFixed(2)}`}</h6>
                  </div>
                  <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                    <img src={impression} />
                  </div>
                </div>
                <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                  {/* <span className="d-inline-flex align-items-center gap-1 text-success-main"></span>  */}
                      <img src={date} /> <span>Seven Days</span>
                </div>
              </div>
            </div>
         </div>
         {/* third col start */}
         <div className="col-lg-3 col-md-3 col-sm-4">
            <div className={`card shadow-none border bg-gradient-start-1-2 h-100`}>
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-light mb-1">Earnings</p>
                    {/* <h6 className="mb-0 text-light">${revenue[2]?.earning.toFixed(2)}</h6> */}
                    <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[2]?.earning.toFixed(2)}` : `$${revenue[2]?.earning.toFixed(2)}`}</h6>
                  </div>
                  <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                    <img src={impression} />
                  </div>
                </div>
                <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                  {/* <span className="d-inline-flex align-items-center gap-1 text-success-main"></span>  */}
                      <img src={date} /> <span>This Month</span>
                </div>
              </div>
            </div>
         </div>
         {/* fourth col start */}
         <div className="col-lg-3 col-md-3 col-sm-4">
            <div className={`card shadow-none border bg-gradient-start-1-3 h-100`}>
              <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <p className="fw-medium text-light mb-1">Earnings</p>
                    {/* <h6 className="mb-0 text-light">${revenue[3]?.earning.toFixed(2)}</h6> */}
                    <h6 className="mb-0 text-light">{pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? `₹${revenue[3]?.earning.toFixed(2)}` : `$${revenue[3]?.earning.toFixed(2)}`}</h6>
                  </div>
                  <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center round-circle earImg">
                    <img src={impression} />
                  </div>
                </div>
                <div className="fw-medium text-sm text-light mt-12 mb-0 d-flex align-items-center gap-2 my-2 dateImg">
                  {/* <span className="d-inline-flex align-items-center gap-1 text-success-main"></span>  */}
                      <img src={date} /> <span>Last Month</span>
                </div>
              </div>
            </div>
         </div>
          </>

        : null
      }
          {/* card end */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Earnings</p>
                  <h6 className="mb-0">55,0000</h6>
                </div>
                <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                <img src={ctr} />
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> Last 7 days
              </p>
            </div>
          </div>
        </div> */}
          {/* card end  */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Earnings</p>
                  <h6 className="mb-0">₹ 15,00000</h6>
                </div>
                <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                <img src={earningImg} />
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> This month
              </p>
            </div>
          </div>
        </div> */}
           {/* card end */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-4 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Total Income</p>
                  <h6 className="mb-0">$42,000</h6>
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> Last 10 days users
              </p>
            </div>
          </div>
        </div> */}
          {/* card end */}
        {/* <div className="col">
          <div className="card shadow-none border bg-gradient-start-5 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Total Expense</p>
                  <h6 className="mb-0">$30,000</h6>
                </div>
                <div className="w-50-px h-50-px bg-red rounded-circle d-flex justify-content-center align-items-center">
                </div>
              </div>
              <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                <img src={date} /> Last 10 days users
              </p>
            </div>
          </div>
        </div> */}
      </div>
      <div className="p-6 bg-gray-100 min-h-screen mt-5">
      {/* <h2 className="text-2xl font-bold mb-6">Publisher Earnings</h2> */}
      <div className="bg-white p-4 rounded-2xl shadow-md">
        <h3 className="text-lg font-semibold mb-4 mt-5" style={{fontSize:"20px"}}>Earnings Day Wise</h3>
        {/* <ResponsiveContainer width="80%" height={300}>
          <BarChart data={earningsData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="publisher" />
            <YAxis />
            <Tooltip cursor={{ fill: "#f0f0f0" }} />
            <Legend />
            <Bar dataKey="earnings">
              {earningsData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer> */}
        {
          reChartData?.length > 0 ? (
                  <ResponsiveContainer width="100%" height={400}>
                  <BarChart data={reChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }} barSize={55}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" tick={{ fill: "#444444", fontSize: 14, fontWeight: "bold" }} />
                    <YAxis yAxisId="left" orientation="left" label={{ value: "Revenue", angle: -90, position: "insideLeft", textAnchor: "middle", fill:"#487fff", fontSize:25,fontWeight:"bold"}} tick={{ fill: "#555555", fontSize: 14, fontWeight: "bold" }} />
                    <YAxis yAxisId="right" orientation="right" label={{ value: "Impressions", angle: -90, dy: -100, position: "insideRight", textAnchor: "middle", fill:"#c3891e", fontSize:25,fontWeight:"bold"}} tick={{ fill: "#555555", fontSize: 14, fontWeight: "bold" }} />
                    <Tooltip 
                      contentStyle={{ backgroundColor: "#222", color:"#ffffff", borderRadius: "8px", border: "none" }} 
                      itemStyle={{ color: "#fff" }} 
                      wrapperStyle={{ outline: "none" }}
                      cursor={{ fill: "rgba(142, 216, 132, 0.3)" }}
                    />
                    <Bar yAxisId="left" dataKey="revenue" fill="#487fff" name="Revenue" />
                    <Bar yAxisId="right" dataKey="impression" fill="#c3891e" name="Impressions" />
                  </BarChart>
                </ResponsiveContainer>
          )
                :null
        }

      </div>
    </div>
    {/* reporting */}
    <h3 className="text-lg font-semibold mb-4 mt-5" style={{fontSize:"20px"}}>Ad Unit Performance (Last 7 days)</h3>
    <table className="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            {
               visibleColumns?.length > 0 ?
                <th>SN</th> : ""
            }
            {
              visibleColumns?.map((tableHead, index)=>(
              <th scope="col" key={index}>{headerMapping[tableHead] || {tableHead}}</th>
              ))
            }
            {/* <th scope="col">SN</th> */}
            {/* <th scope="col">Date</th> */}
            {/* <th scope="col">Domain</th> */}
            {/* <th scope="col">Site Id</th> */}
            {/* <th scope="col">Ad Id</th> */}
            {/* <th scope="col">Ad Unit</th> */}
            {/* <th scope="col">Unit Name</th> */}
            {/* <th scope="col">Ad Count</th> */}
            {/* <th scope="col">Request</th>  */}
            {/* {
              (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ?
                <th scope="col">Request</th> : ""
            } */}
            {/* <th scope="col">Impression</th>
            <th scope="col">CTR</th>
            <th scope="col">Pub Revenue ($)</th>
            <th scope="col">Pub eCPM ($)</th> */}
            {/* {
              (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ? 
              <th scope="col">Pub eCPM ($)</th> : ""
            } */}
          </tr>
        </thead>
        <tbody>
          {
            reportData?.length > 0 ? (
              
              reportData.map((adReportData, adReportDataInd) =>(
                <tr key={adReportDataInd}>
                  {/* <th scope="row">{adReportDataInd + 1}</th> */}
                  <td>{adReportDataInd + 1}</td>
                  {/* <td>{adReportData.date}</td> */}
                  {/* <td>{adReportData.domain}</td> */}
                  {/* <td>{adReportData.site_id}</td> */}
                  {/* <td>{adReportData.ad_id}</td> */}
                  {dataColumns.includes("p_ad_display_name") && <td>{adReportData.p_ad_display_name}</td>}
                  {/* <td>{adReportData.p_ad_unit_name}</td> */}
                  {/* <td>{adReportData.ad_count}</td> */}
                    {dataColumns.includes("requests") && <td>{adReportData.requests}</td>} 
                    {dataColumns.includes("page_views") && pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" && (<td>{adReportData.page_views}</td>)} 
                  {/* {
                    (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ? 
                    <td>{adReportData.requests}</td> : ""
                  } */}
                  {dataColumns.includes("imp") && <td>{adReportData.imp}</td>}
                  {dataColumns.includes("ctr") && <td>{adReportData.ctr != null ? adReportData.ctr : "0"}</td>}
                  {dataColumns.includes("pubRev") && <td>{adReportData.pubRev ?.toFixed(2) || "0"}</td>}
                  {dataColumns.includes("pub_eCPM") && <td>{adReportData.pub_eCPM ?.toFixed(2) || "0"}</td>} 
                  {/* {
                    (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ? 
                    <td>{adReportData.pub_eCPM ?.toFixed(2)}</td> : ""
                  }  */}
                </tr> 
              ))           
            )
            :
            <tr>
              <td colSpan="12" className="text-center">No data available</td>
            </tr>
            
          } 
          {/* <tr>
            <th scope="row">2</th>
            <td>22-02-2025</td>
            <td>MB_CBSEMATERIAL_DHL_BANNER_1</td>
            <td>$0.20</td>
            <td>$80.00</td>
            <td>9.00%</td>
            <td>9</td>
            <td>abc.com</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>22-02-2025</td>
            <td>MB_CBSEMATERIAL_DHL_BANNER_1</td>
            <td>$90.80</td>
            <td>$0.06</td>
            <td>12.06%</td>
            <td>16.40</td>
            <td>adchronix.com</td>
          </tr> */}
        </tbody>
      </table>
      </section>
      
    )
}

export default SummaryPanel;